import type { GetServerSideProps } from 'next';

import Router from './router';

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  return { props: { language: query.lng ?? 'en' } };
};

export default Router;
